import { render, staticRenderFns } from "./mySubscriptions.vue?vue&type=template&id=3332828f&scoped=true"
import script from "./mySubscriptions.vue?vue&type=script&lang=js"
export * from "./mySubscriptions.vue?vue&type=script&lang=js"
import style0 from "./mySubscriptions.vue?vue&type=style&index=0&id=3332828f&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3332828f",
  null
  
)

export default component.exports